var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25001 3.33268C6.71024 3.33268 7.08334 2.95959 7.08334 2.49935C7.08334 2.03911 6.71024 1.66602 6.25001 1.66602H5.00001C3.15906 1.66602 1.66667 3.1584 1.66667 4.99935V14.9993C1.66667 16.8403 3.15906 18.3327 5.00001 18.3327H6.25C6.71024 18.3327 7.08334 17.9596 7.08334 17.4993C7.08334 17.0391 6.71024 16.666 6.25 16.666H5.00001C4.07953 16.666 3.33334 15.9198 3.33334 14.9993L3.33334 4.99935C3.33334 4.07887 4.07953 3.33268 5.00001 3.33268H6.25001Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9226 10.5886C19.248 10.2632 19.248 9.73553 18.9226 9.41009L15.5893 6.07676C15.2638 5.75132 14.7362 5.75132 14.4107 6.07676C14.0853 6.4022 14.0853 6.92983 14.4107 7.25527L16.3215 9.16602L6.66667 9.16602C6.20643 9.16602 5.83334 9.53911 5.83334 9.99935C5.83334 10.4596 6.20643 10.8327 6.66667 10.8327L16.3215 10.8327L14.4107 12.7434C14.0853 13.0689 14.0853 13.5965 14.4107 13.9219C14.7362 14.2474 15.2638 14.2474 15.5893 13.9219L18.9226 10.5886Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.ac20b47a8cd5e71a4de499240ea2c649.svg";
export { ForwardRef as ReactComponent };